function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M18.35 19.68a3.63 3.63 0 01-3.4 2.32h-5.9a3.62 3.62 0 01-3.4-2.32c-.55-1.42-.17-2.99.95-4.01L10.65 12h2.71l4.04 3.67a3.635 3.635 0 01.95 4.01z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.82 18.14h-3.64a.68.68 0 010-1.36h3.64c.38 0 .68.31.68.68 0 .37-.31.68-.68.68zm4.53-13.82A3.63 3.63 0 0014.95 2h-5.9a3.63 3.63 0 00-2.44 6.33L10.65 12h2.71l4.04-3.67a3.635 3.635 0 00.95-4.01zm-4.53 2.91h-3.64a.68.68 0 01-.68-.68c0-.37.31-.68.68-.68h3.64c.38 0 .68.31.68.68 0 .37-.31.68-.68.68z"
})));